import { render, staticRenderFns } from "./IcoDashboardTemplates.vue?vue&type=template&id=409c67e2&lang=html"
import script from "./IcoDashboardTemplates.vue?vue&type=script&lang=js"
export * from "./IcoDashboardTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports